import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FlaskConical, FileCheck2, Snowflake, ShieldCheck, ArrowUpRight } from "lucide-react";

const ITEMS = [
  { Icon: FlaskConical, title: "Reference-Grade", sub: "Sourced & prepared to specification" },
  { Icon: FileCheck2, title: "Transparent Labeling", sub: "Contents stated on every vial" },
  { Icon: Snowflake, title: "Cold-Chain", sub: "Lyophilized, sealed, discreet" },
  { Icon: ShieldCheck, title: "Research Use Only", sub: "21+ verified, compliance-first" },
];

export default function TrustStrip() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 border-t border-zinc-900" data-testid="trust-strip">
      <div className="flex items-center justify-between mb-10 flex-wrap gap-4">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">The Molecularix Standard</p>
        <Link to="/standards" data-testid="trust-strip-link"
          className="group inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
          Our Standards <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-900 border border-zinc-900">
        {ITEMS.map(({ Icon, title, sub }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.06 }}
            className="bg-[#0A0A0A] p-6 md:p-8"
            data-testid={`trust-strip-item-${i}`}
          >
            <Icon size={20} className="text-[#D4AF37] mb-4" />
            <p className="font-serif text-lg font-light leading-tight mb-1">{title}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-[#71717A] leading-relaxed">{sub}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
